<style lang="less">
  @import "./Error.less";
</style>

<template>
  <div class="error">

  </div>
</template>

<script>
import Error from './Error.js'
export default {
  ...Error
}
</script>
